<template>
<div class="container">

    <div class="card">
      <div class=" card-body text-center">
        <h3>Spring-Rechnungsimport</h3>
        <b-form-group>
            <b-form-file id="file-small" size="md" v-model="fileData" @change="onChange" placeholder="keine Datei ausgewählt" class="w-auto centered-file-input">
            </b-form-file>
        </b-form-group>
        <b-btn variant="primary mb-2" size="md" @click="uploadFile" :disabled="isRequestInProgress || disableImport">
          importieren <BSpinner small v-show="isRequestInProgress"></BSpinner>
        </b-btn>
      </div>
    </div>
	<b-overlay
			id="asd"
			:show="requestQueryInProgress"
			variant="light"
			opacity="0.5"
			blur="2px"
			rounded="lg"
			class="mt-3"
	>
		<b-card>
			<div class="d-flex justify-content-between col-md-12">
				<div class="p-2"><h3>Verlauf</h3></div>
				<div>
					<b-btn variant="secondary" @click="getAllImportrequests()">
						<i class="bi bi-arrow-clockwise"></i>
					</b-btn>
				</div>
			</div>
			<b-table
					:items="importRequests"
					:fields="fields"
					:tbody-tr-class="rowClass"
					sticky-header="200px"
					small
			>
				<template #cell(status)="row">
					{{ translateStatus(row.item.status) }}
				</template>
				<template #cell(errorJSON)="row">
					<b-btn
							v-if="row.item.errorJSON"
							@click="openImportRequestModal(row.item)"
							:id="'eanAsinListButton'+row.item.id">
						<i class="bi bi-list"></i>
					</b-btn>
				</template>
			</b-table>
		</b-card>
	</b-overlay>
  <b-modal v-model="showImportInfoModal" title="Folgende Fehler sind aufgetreten:">
    <div v-if="selectedImportRequest.status === 'failed'">
			{{ selectedImportRequest.errorJSON }}
		</div>
		<div v-else>
			<span v-for="(value, key) in importErrors?.original" :key="key">
				{{ value }} <br>
			</span>
		</div>
  </b-modal>
    <modal-error-component v-model="modalError"></modal-error-component>
</div>
</template>

<script>
export default {
  name: "GeneralImport",
  data() {
    return {
      data: null,
      fileData: null,
      isRequestInProgress: false,
			requestQueryInProgress: false,
			importErrors: null,
			importRequests: null,
			selectedImportRequest: null,
      showImportInfoModal: false,
			fields: [
				{key: 'fileName', label: 'Dateiname'},
				{key: 'status', label: 'Status'},
				{key: 'requestedAt', label: 'Anfragenstart'},
				{key: 'completedAt', label: 'Fertigstellung'},
				{key: 'errorJSON', label: 'Fehler'},
			],
      modalError: {
        show: false,
        message: "unpopulated",
        error: "unpopulated",
        title: "unpopulated"
      },
			reloadInterval: null,
    };
  },
  computed: {
    disableImport() {
      return this.fileData == null;
    }
  },
  methods: {
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: 'binary' });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
           this.fileData = {
             name: this.file.name,
             data: XLSX.utils.sheet_to_json(ws, { header: 1 })
           };
        }
        reader.readAsBinaryString(this.file);
      }
    },
    uploadFile() {
      this.isRequestInProgress = true;
      axios.post('/generalimport/spring', {fileData: this.fileData})
      .then(response => {
        this.isRequestInProgress = false;
        this.$bvToast.toast('Daten wurden gepseichert', {
          title: 'Erfolgreich',
          variant: 'success',
          solid: true,
          autoHideDelay: 5000
        })
      })
      .catch(error => {
        this.isRequestInProgress = false;
        this.modalError = {
          show: true,
          message: 'Folgender Fehler ist aufgetreten',
          error: error.response?.data?.message ?? error.message,
          title: 'Import'
        }
      });
    },
		getAllImportrequests(){
			this.requestQueryInProgress = true;
			axios.get('/generalimport/requests/all')
				.then(response => {
					this.importRequests = response.data;
					this.requestQueryInProgress = false;
				})
				.catch(error => {
					this.requestQueryInProgress = false;
					this.modalError = {
						show: true,
						message: 'Folgender Fehler ist aufgetreten',
						error: error.response?.data?.message ?? error.message,
						title: 'Importanrequests abfragen'
					}
				});
		},
		translateStatus(status){
			switch (status) {
				case 'created':
					return 'Erstellt';
				case 'processing':
					return 'In Bearbeitung';
				case 'completed':
					return 'Abgeschlossen';
				case 'failed':
					return 'Fehlgeschlagen';
				default:
					return status;
			}
		},
		openImportRequestModal(item){
				this.selectedImportRequest = item;
				this.importErrors = JSON.parse(this.selectedImportRequest.errorJSON);
				this.showImportInfoModal = true;
		},
  },
  created(){
		this.getAllImportrequests();
  },
	beforeUnmount() {
		if (this.reloadInterval) {
			clearInterval(this.reloadInterval);
		}
	},
	mounted() {
		this.reloadInterval = setInterval(() => {
			this.getAllImportrequests();
		}, 30000); // every 30 seconds
	},
}
</script>


<style>
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'browse';
}
.custom-file-input:lang(de) ~ .custom-file-label::after {
  content: 'durchsuchen';
}
.centered-file-input .custom-file-label {
  display: flex;
  align-items: center;
  height: 100%;
  text-align: center;
}
</style>